import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container } from 'react-bootstrap';

import { format, parseISO } from 'date-fns';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';

import Input from '../../components/Input';

import Modal from '../../components/Modal';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';
import api from '../../services/api';
import Loading from '../../components/Loading';
import {
  formataTelefone,
  statusAgendamento,
  STATUS_AGENDA,
} from '../../utils/funcoes';
import socket from '../../services/socket';
import Historico from '../../components/Historico';
import getResponseErrors from '../../utils/getResponseErrors';
import ListaTeleAtendimento from '../../components/ListaTeleAtendimento';
import { useVideoConference } from '../../hooks/videoConference';

export interface IFormBusca {
  dataBusca: string;
  agenda: string;
  somenteLista: string;
}

export interface IListaAgendamentosTeleatendimentoDTO {
  AgeCodigo: number;
  AgeChave: string;
  AgeConfCodigo: number;
  AgeInicio: Date;
  AgeFim: Date;
  horario: string;
  AgeStatus: number;
  AgeConfirmado: number;
  AgeOrigem: number;
  AgeClinica: number;
  AgeTipo: number;
  AgeTelemedicina: number;
  created_at: Date;
  updated_at: Date;
  PerNome: string;
  PacCodigo: number;
  PacNome: string;
  PacEmail: string;
  PacCelular: string;
  celular: string;
  medico: string;
  urlVideo?: string;
  statusTelemedicina: number;
  statusUsuario: number;
  dataPrimeiroStatusTelemedicina: Date;
  dataEntrada: string;
  badge?: { lbel: string; color: string; dot: string };
}

export interface IFilaChamado {
  AgeCodigo: number;
  PacCodigo: number;
  CliCodigo: number;
  codClinica?: number;
  PacNome: string;
  Sala: string;
  Texto: string;
  Arquivo?: string;
  created_at?: Date;
}

export interface IMudarStatus {
  AgeCodigo: number;
  AgeChave: string;
  status: number;
}

export interface IRetornoMudarStatus {
  id: number;
  AgeCodigo: number;
  AgeChave: string;
  status: number;
  UsuCodigo: number;
  created_at: Date;
  urlVideo: string;
}

const AgendaTeleAtendimento: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  function useQuery(): URLSearchParams {
    return new URLSearchParams(location.search);
  }

  const query = useQuery();

  const { addToast } = useToast();
  const { user } = useAuth();

  const { isOpen, setIsOpen, setUrl, setMinimized, url } = useVideoConference();
  const [loading, setLoading] = useState(false);
  const [listaEspera, setListaEspera] = useState<
    IListaAgendamentosTeleatendimentoDTO[]
  >([]);

  const formRefBusca = useRef<FormHandles>(null);

  const [showModalHistorico, setShowModalHistorico] = useState(false);
  const [pacienteSelecionado, setPacienteSelecionado] = useState<
    number | undefined
  >(undefined);

  const [dadosBusca, setDadosBusca] = useState(() => {
    return {
      codigoAgenda: query.get('agenda') || undefined,
      dataAgenda: query.get('data') || format(new Date(), 'yyyy-MM-dd'),
      somenteLista: query.get('somenteLista')
        ? query.get('somenteLista') === 'true'
        : true,
      atualiza: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    };
  });

  useEffect(() => {
    const handleNewAtendimento = (): void => {
      formRefBusca.current?.submitForm();
    };
    socket.on('mudouStatus', handleNewAtendimento);
    return () => {
      socket.removeEventListener('mudouStatus', handleNewAtendimento);
    };
  }, [dadosBusca.codigoAgenda]);

  const initialData = {
    dataBusca: dadosBusca.dataAgenda,
    agenda: dadosBusca.codigoAgenda || '',
    somenteLista: dadosBusca.somenteLista || false,
  };

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    formRefBusca.current?.setErrors({});
    const schema = Yup.object().shape({
      dataBusca: Yup.date()
        .typeError('Digite uma data válida')
        .required('Obrigatório'),
    });

    await schema.validate(dados, {
      abortEarly: false,
    });

    setDadosBusca({
      codigoAgenda: dados.agenda,
      dataAgenda: dados.dataBusca,
      somenteLista: (dados?.somenteLista?.toString() || '') === 'true',
      atualiza: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    });
  }, []);

  useEffect(() => {
    async function buscarLista(): Promise<void> {
      setLoading(true);
      try {
        const hoje = format(new Date(), 'yyyy-MM-dd');
        const response = await api.get<
          [IListaAgendamentosTeleatendimentoDTO[], number]
        >(
          `/agendamentos/buscaApp?pagina=1&limite=30&AgeInicio=${hoje}&AgeFim=${hoje}`,
        );

        if (response.data[1] === 0) setListaEspera([]);

        console.log(response.data[0]);

        const retornoFormatado = response.data[0].map(lista => {
          let icone = statusAgendamento.find(
            status => status.id === Number(lista.AgeStatus),
          );
          if (lista.AgeStatus === STATUS_AGENDA.AGENDADO)
            icone = statusAgendamento.find(
              status =>
                status.id === Number(lista.AgeStatus + lista.AgeConfirmado),
            );

          console.log('DATA =>', lista.dataPrimeiroStatusTelemedicina);
          let dataEntrada = '';

          if (
            lista.dataPrimeiroStatusTelemedicina !== undefined &&
            lista.dataPrimeiroStatusTelemedicina !== null
          )
            dataEntrada = format(
              parseISO(lista.dataPrimeiroStatusTelemedicina.toString()),
              'HH:mm',
            );
          return {
            ...lista,
            horario: format(parseISO(lista.AgeInicio.toString()), 'HH:mm'),
            celular: formataTelefone(lista.PacCelular),
            icone,
            atendido: lista.AgeStatus === STATUS_AGENDA.ATENDIDO,
            dataEntrada,
          };
        });
        setListaEspera(retornoFormatado);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagemErro = getResponseErrors(error);
          addToast({
            title: 'Não foi possível carregar lista de espera',
            type: 'error',
            description: mensagemErro,
          });
        }
      } finally {
        setLoading(false);
      }
    }

    buscarLista();
  }, [dadosBusca, history, location.search, addToast]);

  const handleHistorico = useCallback(pacCodigo => {
    setPacienteSelecionado(pacCodigo);
    setShowModalHistorico(true);
  }, []);

  const handleFecharHistorico = useCallback(() => {
    setPacienteSelecionado(undefined);
    setShowModalHistorico(false);
  }, []);

  const handleMudarStatus = useCallback(
    async (dados: IMudarStatus) => {
      try {
        setLoading(true);

        const retorno = await api.patch<IRetornoMudarStatus>(
          `/teleatendimento/statusTelemedicina/${dados.AgeChave}`,
          { status: dados.status },
        );

        const { urlVideo } = retorno.data;
        history.push(
          // eslint-disable-next-line prettier/prettier
          `/pacienteTeleAtendimento/${dados.AgeCodigo
          }?urlVideo=${encodeURIComponent(
            `${urlVideo}&name=${user.UsuNome.split(' ')[0]}`,
          )}`,
        );
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [history, user],
  );

  const handleAbrirAtendimento = useCallback(
    (AgeCodigo: number, urlVideo: string) => {
      history.push(
        `/pacienteTeleAtendimento/${AgeCodigo}?urlVideo=${encodeURIComponent(
          urlVideo,
        )}`,
      );

      // const url = `${NAVIGATION_ADMIN.PEDIDOS_EXPEDICAO_ETIQUETA.link}/${id}`

      // window.open(
      //   `/pacienteTeleAtendimento/${AgeCodigo}?urlVideo=${encodeURIComponent(
      //     `${urlVideo}&name=${user.UsuNome.split(' ')[0]}`,
      //   )}`,
      //   '_blank',
      //   'width=420,height=830,menubar=no,toolbar=no,location=no,status=no,scrollbars=no,resizable=no',
      // );

      // setUrl(`${urlVideo}&name=${user.UsuNome.split(' ')[0]}`);
      // setIsOpen(true);
    },
    [history],
  );

  return (
    <Container fluid className="mt-2">
      {loading && <Loading backgroundBlack={false} />}
      <>
        {showModalHistorico && (
          <Modal
            show={showModalHistorico}
            titulo="Historico"
            handleFecharModal={handleFecharHistorico}
            large
          >
            {pacienteSelecionado && (
              <Historico pacCodigo={pacienteSelecionado} />
            )}
          </Modal>
        )}

        <>
          <div className="bg-white border p-2 mb-2">
            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <div className="row">
                <div className="col-md-2 form-group">
                  <Input
                    name="dataBusca"
                    label="Data"
                    placeholder=""
                    type="date"
                  />
                </div>

                <div className="col-md-3">
                  <div className="input-group-append mt-3">
                    <Button type="submit" variant="secondary-outline">
                      BUSCAR
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          </div>

          <div className="bg-white border p-2">
            {listaEspera.length > 0 ? (
              <>
                <ListaTeleAtendimento
                  dadosBusca={dadosBusca}
                  listaEspera={listaEspera}
                  mudarStatus={handleMudarStatus}
                  abrirHistorico={handleHistorico}
                  abrirAtendimento={handleAbrirAtendimento}
                />
              </>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: '250px' }}
              >
                <h5>Nenhum paciente na lista de espera de TeleAtendimento</h5>
              </div>
            )}
          </div>
        </>
      </>
    </Container>
  );
};

export default AgendaTeleAtendimento;
